/**
 * Validation problem code for cart items that cannot be shipped (e.g. alcohol in restricted cases).
 * Used when matching validateCart problems to show item-level messages and control UI (e.g. auto-expand order details).
 */
export const INVALID_CONTENT_CODE = 'INVALID_CONTENT'

/**
 * Validation problem code for cart items manually excluded from a fulfillment type (e.g. merchant opted out of shipping for this item).
 * Used to differentiate shipping exclusions from alcohol/state restrictions.
 */
export const INVALID_FULFILLMENT_CODE = 'INVALID_FULFILLMENT'
